import { TalentAutocompleteOption } from "../../common/components/functional/fields/talentAutocomplete/talentAutocompleteUtils";
import { CustomerUserAutocompleteOption } from "../../common/components/functional/fields/customerUsersAutocomplete/customerUsersAutocompleteUtils";
import { ParticipantOption, ParticipantType } from "./types/common";

export const toTalentParticipant = (
  talent: TalentAutocompleteOption,
): ParticipantOption => ({
  id: talent.id,
  name: talent.name,
  type: ParticipantType.TALENT,
  city: talent.city,
  talentStatus: talent.talentStatus,
});

export const toCustomerParticipant = (
  customerUser: CustomerUserAutocompleteOption,
): ParticipantOption => ({
  id: customerUser.id,
  name: customerUser.name,
  type: ParticipantType.CUSTOMER,
  customerCompanyName: customerUser.customerCompanyName,
});
